import { Value } from './ParameterKeyValue';
import Parameter, { BoolClause } from './Parameter';

export type ParameterHash = { [key: string]: Value };

/**
 * class for composing fetch parameters for a fhir resource
 *
 * @export
 * @class ParameterSet
 */
export default class ParameterSet {
  private _parameters: Parameter[];

  constructor(parameters: Parameter[]) {
    this._parameters = parameters || [];
  }

  get fetchParameters(): ParameterHash {
    const allParameters: { [key: string]: Value } = {};

    const validParameters = this._parameters.filter(
      parameter =>
        parameter.parameterKeyValue && parameter.parameterKeyValue.hasValue,
    );
    validParameters.forEach(param => {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      allParameters[param.parameterKeyValue.key] =
        param.parameterKeyValue.value;
    });

    return allParameters;
  }

  async getFSSClause(): Promise<BoolClause | null> {
    const clausePromises = this._parameters.map(_ => _.getFSSClause());
    const clauses = (await Promise.all(clausePromises)).filter(Boolean);
    if (!clauses.length) return null;

    return {
      bool: {
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        must: clauses,
      },
    };
  }
}
